<template>

    <v-btn rounded class="btn-excel-4" small dark color='#3fbdbd'>
        <download-csv :data="data" type='csv' name="impressions.csv">
            <div class="text-csv d-flex justify-center align-center">
                exportar CSV
            </div>
        </download-csv>
    </v-btn>

</template>

<script>
export default {

    name: 'ButtonsToCsvXls',
    
    props: ['data', 'fields']

}
</script>

